var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
      ],
      staticClass: "form-row",
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "pui-form-grid-column",
              rawName: "v-pui-form-grid-column",
              value: 3,
              expression: "3",
            },
          ],
          staticClass: "mb-1",
          staticStyle: { "min-width": "100px" },
        },
        [_vm._v(" " + _vm._s(_vm.buildingBlockName()) + " ")]
      ),
      _c(
        "div",
        {
          directives: [
            { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
          ],
          staticClass: "form-row",
        },
        [
          !_vm.isBoiler()
            ? _c(
                "div",
                [
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                        },
                      ],
                      staticClass: "input-field",
                      attrs: {
                        label:
                          _vm.index == 0
                            ? this.$t(
                                "operationalData.entryView.tabs.componentsTab.grossCapacity"
                              )
                            : "",
                        "has-label-padding": false,
                      },
                    },
                    [
                      _c("custom-input", {
                        attrs: {
                          id: "customInputGrossCapacity",
                          "is-disabled": _vm.isReadOnly(),
                          min: 0,
                          required: false,
                          precision: _vm.componentsPrecision,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.atInputChange()
                          },
                        },
                        model: {
                          value: _vm.data.grossCapacity,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "grossCapacity", $$v)
                          },
                          expression: "data.grossCapacity",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.isBoiler()
            ? _c(
                "div",
                [
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                        },
                      ],
                      staticClass: "input-field",
                      attrs: {
                        label:
                          _vm.index == 0
                            ? this.$t(
                                "operationalData.entryView.tabs.componentsTab.netCapacity"
                              )
                            : "",
                        "has-label-padding": false,
                      },
                    },
                    [
                      _c("custom-input", {
                        attrs: {
                          id: "customInpuNetCapacity",
                          "is-disabled": _vm.isReadOnly(),
                          min: 0,
                          required: false,
                          precision: _vm.componentsPrecision,
                        },
                        on: { change: _vm.atInputChange },
                        model: {
                          value: _vm.data.netCapacity,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "netCapacity", $$v)
                          },
                          expression: "data.netCapacity",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.isBoiler()
            ? _c(
                "div",
                [
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                        },
                      ],
                      staticClass: "input-field",
                      attrs: {
                        label:
                          _vm.index == 0
                            ? this.$t(
                                "operationalData.entryView.tabs.componentsTab.grossGenVolumeMwh"
                              )
                            : "",
                        "has-label-padding": false,
                      },
                    },
                    [
                      _c("custom-input", {
                        attrs: {
                          id: "customInputGrossGenVolumeMwh",
                          "is-disabled": _vm.isReadOnly(),
                          min: 0,
                          required: false,
                          precision: _vm.componentsPrecision,
                        },
                        on: { change: _vm.atInputChange },
                        model: {
                          value: _vm.data.grossGenVolumeMwh,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "grossGenVolumeMwh", $$v)
                          },
                          expression: "data.grossGenVolumeMwh",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.isBoiler()
            ? _c(
                "div",
                [
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                        },
                      ],
                      staticClass: "input-field",
                      attrs: {
                        label:
                          _vm.index == 0
                            ? this.$t(
                                "operationalData.entryView.tabs.componentsTab.netGenVolumeMwh"
                              )
                            : "",
                        "has-label-padding": false,
                      },
                    },
                    [
                      _c("custom-input", {
                        attrs: {
                          id: "customInputNetGenVolumeMwh",
                          "is-disabled": _vm.isReadOnly(),
                          min: 0,
                          required: false,
                          precision: _vm.componentsPrecision,
                        },
                        on: { change: _vm.atInputChange },
                        model: {
                          value: _vm.data.netGenVolumeMwh,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "netGenVolumeMwh", $$v)
                          },
                          expression: "data.netGenVolumeMwh",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                    },
                  ],
                  staticClass: "input-field",
                  attrs: {
                    label:
                      _vm.index == 0
                        ? this.$t(
                            "operationalData.entryView.tabs.componentsTab.operationHours"
                          )
                        : "",
                    "has-label-padding": false,
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      id: "customInputOperationHours",
                      "is-disabled": _vm.isReadOnly(),
                      min: 0,
                      required: false,
                      precision: _vm.componentsPrecision,
                    },
                    on: { change: _vm.atInputChange },
                    model: {
                      value: _vm.data.operationHours,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "operationHours", $$v)
                      },
                      expression: "data.operationHours",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isBoiler()
            ? _c(
                "div",
                [
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                        },
                      ],
                      staticClass: "input-field",
                      attrs: {
                        label:
                          _vm.index == 0
                            ? this.$t(
                                "operationalData.entryView.tabs.componentsTab.generatorOpHours"
                              )
                            : "",
                        "has-label-padding": false,
                      },
                    },
                    [
                      _c("custom-input", {
                        attrs: {
                          id: "customInputGeneratorOpHours",
                          "is-disabled": _vm.isReadOnly(),
                          min: 0,
                          required: false,
                          precision: _vm.componentsPrecision,
                        },
                        on: { change: _vm.atInputChange },
                        model: {
                          value: _vm.data.generatorOpHours,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "generatorOpHours", $$v)
                          },
                          expression: "data.generatorOpHours",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                    },
                  ],
                  staticClass: "input-field",
                  attrs: {
                    label:
                      _vm.index == 0
                        ? this.$t(
                            "operationalData.entryView.tabs.componentsTab.hotStarts"
                          )
                        : "",
                    "has-label-padding": false,
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      id: "customInputHotStarts",
                      "is-disabled": _vm.isReadOnly(),
                      min: 0,
                      required: false,
                    },
                    on: { change: _vm.atInputChange },
                    model: {
                      value: _vm.data.hotStarts,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "hotStarts", $$v)
                      },
                      expression: "data.hotStarts",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                    },
                  ],
                  staticClass: "input-field",
                  attrs: {
                    label:
                      _vm.index == 0
                        ? this.$t(
                            "operationalData.entryView.tabs.componentsTab.warmStarts"
                          )
                        : "",
                    "has-label-padding": false,
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      id: "customInputWarmStarts",
                      "is-disabled": _vm.isReadOnly(),
                      min: 0,
                      required: false,
                    },
                    on: { change: _vm.atInputChange },
                    model: {
                      value: _vm.data.warmStarts,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "warmStarts", $$v)
                      },
                      expression: "data.warmStarts",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                    },
                  ],
                  staticClass: "input-field",
                  attrs: {
                    label:
                      _vm.index == 0
                        ? this.$t(
                            "operationalData.entryView.tabs.componentsTab.coldStarts"
                          )
                        : "",
                    "has-label-padding": false,
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      id: "customInputColdStarts",
                      "is-disabled": _vm.isReadOnly(),
                      min: 0,
                      required: false,
                    },
                    on: { change: _vm.atInputChange },
                    model: {
                      value: _vm.data.coldStarts,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "coldStarts", $$v)
                      },
                      expression: "data.coldStarts",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isBoiler()
            ? _c(
                "div",
                [
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                        },
                      ],
                      staticClass: "input-field",
                      attrs: {
                        label:
                          _vm.index == 0
                            ? this.$t(
                                "operationalData.entryView.tabs.componentsTab.goodStarts"
                              )
                            : "",
                        "has-label-padding": false,
                      },
                    },
                    [
                      _c("custom-input", {
                        attrs: {
                          id: "customInputGoodStarts",
                          "is-disabled": _vm.isReadOnly(),
                          min: 0,
                          required: false,
                        },
                        on: { change: _vm.atInputChange },
                        model: {
                          value: _vm.data.goodStarts,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "goodStarts", $$v)
                          },
                          expression: "data.goodStarts",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.isBoiler()
            ? _c(
                "div",
                [
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                        },
                      ],
                      staticClass: "input-field",
                      attrs: {
                        label:
                          _vm.index == 0
                            ? this.$t(
                                "operationalData.entryView.tabs.componentsTab.failedStarts"
                              )
                            : "",
                        "has-label-padding": false,
                      },
                    },
                    [
                      _c("custom-input", {
                        attrs: {
                          id: "customInputFailedStarts",
                          "is-disabled": _vm.isReadOnly(),
                          min: 0,
                          required: false,
                        },
                        on: { change: _vm.atInputChange },
                        model: {
                          value: _vm.data.failedStarts,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "failedStarts", $$v)
                          },
                          expression: "data.failedStarts",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                    },
                  ],
                  staticClass: "input-field",
                  attrs: {
                    label:
                      _vm.index == 0
                        ? this.$t(
                            "operationalData.entryView.tabs.componentsTab.equivalentOpHours"
                          )
                        : "",
                    "has-label-padding": false,
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      id: "customInputEquivalentOpHours",
                      "is-disabled": _vm.isReadOnly(),
                      min: 0,
                      required: false,
                      precision: _vm.componentsPrecision,
                    },
                    on: { change: _vm.atInputChange },
                    model: {
                      value: _vm.data.equivalentOpHours,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "equivalentOpHours", $$v)
                      },
                      expression: "data.equivalentOpHours",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }